/* ─── Site-wide small-print footer ─────────────────────────────────────── */

.footer {
  border-top: 1px solid var(--color-border);
  padding: 16px 20px;
  text-align: center;
  font-size: 0.78rem;
  color: var(--color-text-muted);
  font-family: var(--font-family-base);
  line-height: 1.6;
}

.inner {
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 4px 12px;
}

.separator {
  color: var(--color-border-strong);
  user-select: none;
}

.link {
  color: var(--color-text-muted);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.link:hover {
  color: var(--color-accent);
}
